<template>
  <button dusk="filter-button" type="button" @click="show = true" :class="{'shadow-xl': show}">
    <slot />
    <portal v-if="show" to="dropdown">
      <div>
        <div class="fixed z-40 inset-0" @click="show = false" />
        <section
          dusk="filter-dropdown"
          ref="dropdown"
          role="tooltip"
          class="filter w-64 drop-down-content z-50 bg-white rounded-lg"
          @click.stop
        >
          <header class="title-block flex items-center justify-between py-3 px-4 bg-smoke text-yank ">
            <div @click="back" class="flex items-center">
              <Arrow  v-show="title!='Filter by'" class="transform rotate-90 mr-5 cursor-pointer"/>
              <h3 class=" font-light font-overpass  my-2 select-none">
                {{title}}
              </h3>
            </div>
            <button v-show="!schedulerFilter" @click="clearFilters" type="button" dusk="clear-filters-button" class="reset-button select-none focus:outline-none">
              Clear
            </button>
          </header>
          <slot name="filters" class="max-h-80 overflow-y-scroll"/>

          <footer v-show="!schedulerFilter" class="bg-platinumMild px-4 py-3">
            <button
              @click="applyFilters"
              type="button"
              class="apply-button"
              dusk="apply-filters-button"
            >
              Apply Filters
            </button>
          </footer>

          <div id="arrow" data-popper-arrow></div>
        </section>
      </div>
    </portal>
  </button>
</template>

<script>
  import { createPopper } from '@popperjs/core';

  import Arrow from '@/components/svg/Arrow';
  export default {
    props: {
      placement: {
        type: String,
        default: 'bottom-start',
      },
      title:{
        type: String,
        default: 'Filter by',
      },
      schedulerFilter:{
        type:Boolean,
        default:false
      },
      boundary: {
        type: String,
        // default: 'scrollParent',
      },

      activeFilters: Object,

      categories: Array,
    },

    data() {
      return {
        show: false,
        enabledFilters: [],
        filters: {
          type: null,
        }
      }
    },

    components: {
      Arrow,
    },

    watch: {
      show(show) {
        if (show) {
          this.parseActiveFilters()
          this.$nextTick(() => {
            this.popper = createPopper(this.$el, this.$refs.dropdown, {
              placement: this.placement,
              modifiers: [
                {
                  name: 'preventOverflow',
                  options: {
                    boundary: this.boundary,
                  }
                },
                {
                  name: 'offset',
                  options: {
                    offset: [0, 8],
                  }
                }
              ]
            })
          })
        } else if (this.popper) {
          setTimeout(() => this.popper.destroy(), 100)
        }
      },
    },

    methods: {
      parseActiveFilters() {
        this.resetFilters()

        if (! Object.keys(this.activeFilters).length) {
          return
        }

        this.enabledFilters = Object.keys(this.activeFilters)
        this.enabledFilters.forEach(filterName => {
          this.$set(this.filters, filterName, this.activeFilters[filterName])
        })
      },

      resetFilters() {
        Object.keys(this.filters).forEach(filterName => {
          this.$set(this.filters, filterName, null)
        })

        this.enabledFilters = []
      },

      handleEscapeKey(e) {
        if (e.keyCode === 27) {
          this.show = false
        }
      },

      clearFilters() {
        this.show = false
        this.resetFilters()
        this.$emit('clear-filters')
      },

      applyFilters() {
        this.show = false
        this.$emit('apply-filters', this.filters)
      },
       back(){
      this.$emit('back')
    }

    },

    mounted() {
      if (this.categories && this.categories.length) {
        this.categories.forEach(category => this.$set(this.filters, category.slug, null))
      }

      document.addEventListener('keydown', this.handleEscapeKey)
    },

    destroyed() {
      document.removeEventListener('keydown', this.handleEscapeKey)
    },
   
  }
</script>

<style lang="scss" scoped>
  .filter {
    box-shadow: 1px 12px 37px rgba(64,64,64,0.1),0px 4px 7px rgba(55,54,77,0.19);
  }

  .reset-button {
    @apply text-xs uppercase rounded bg-aquamarine px-1 h-6 text-white flex items-center justify-center border border-aquamarine transition duration-300 ease-in-out;

    &:hover {
      background-color: #66f0b6;
    }
  }

  .apply-button {
    @apply w-full text-yank bg-white border border-platinum transition duration-300 ease-in-out rounded py-2 px-3 font-semibold text-sm hover:border-platinum active:bg-yank active:text-white active:border-yank focus:bg-yank focus:text-white focus:border-yank focus:outline-none;

    &:hover {
      box-shadow: 0 2px 11px rgba(55,54,77,0.08);
    }
  }

  #arrow,
  #arrow::before {
    position: absolute;
    width: 8px;
    height: 8px;
    z-index: -1;
  }

  #arrow::before {
    @apply bg-platinumMild;
    content: '';
    transform: rotate(45deg);
  }

  [data-popper-placement^='top'] > #arrow {
    bottom: -4px;
  }

  [data-popper-placement^='bottom'] > #arrow {
    top: -4px;
  }

  [data-popper-placement^='left'] > #arrow {
    right: -4px;
  }

  [data-popper-placement^='right'] > #arrow {
    left: -4px;
  }
</style>
